<template>
	<select v-if="visible" v-model="dataValue" :disabled="ro" :class="[ clazz, errorClass ]" :style="style" v-bind="attrs">
		<option v-for="li in normalizedListItems" :value="li.value">{{ li.name }}</option>
	</select>
</template>

<script setup lang="ts">
import {computed} from "vue";
import useEditor, {type EditorProps, editorProps} from "@fd/editors/Editor.ts";
import {DONT_RING, RING_AT_START, RingSelect} from "@t/fd/editor/RingSelect.ts";
import {ListItemBase} from "@t/list/List.ts";
import {injectEnv} from "@fd/Environment.ts";
import {formatRingInterval} from "@fd/editors/RingIntervalUtils.ts";

const uprops = defineProps({...editorProps});
const props = uprops as EditorProps;

const rs = computed<RingSelect>(() => props.part as RingSelect);
const env = injectEnv();
const {visible, value, clazz, errorClass, style, ro, listItems, dataToScreen, localData, tabindexBinding} = useEditor(props);

const dataValue = computed<number>({
	get(): any {
		if (typeof value.value === "number") {
			let valAbs = Math.abs(value.value);
			if (valAbs > 0 && valAbs < 1000) return RING_AT_START;
			return value.value;
		}
		return DONT_RING;
	},
	set(v:any) {
		if (typeof v === "string") v = parseInt(v);
		value.value = v;
	}
});

const numValues = computed<number[]>(() => {
	const all: Set<number> = new Set<number>();
	for (let li of listItems.value) {
		all.add(parseInt(li.value));
	}
	all.add(dataValue.value);
	all.add(DONT_RING);
	all.add(RING_AT_START);
	return Array.from(all).sort((a, b) => a - b);
});

const normalizedListItems = computed<ListItemBase[]>(() => {
	const lis:ListItemBase[] = [];
	for (let val of numValues.value) {
		lis.push({ value:val.toString(), name: generateNameForValue(val) });
	}
	return lis;
});

function generateNameForValue(val:number):string {
	return formatRingInterval(env, val, rs.value.labels);
}

const attrs = computed(() => {
	const a:any = tabindexBinding();
	return a;
});

</script>

<style>

</style>